import { Typography, useTheme, alpha } from "@mui/material";

type Props = {
  status: string | number;
};

export const StatusChip = ({ status }: Props) => {
  const theme = useTheme();

  let color: string;
  let label: string;

  if (status === "Paid" || status === "Done") {
    color = theme.palette.success.main;
    label = String(status);
  } else if (status === "Pending" || status === "In Progress") {
    color = theme.palette.warning.main;
    label = String(status);
  } else if (typeof status === "number" && status >= 0 && status <= 99) {
    color = theme.palette.warning.main;
    label = `${status}%`;
  } else {
    color = theme.palette.error.main;
    label = String(status);
  }

  return (
    <Typography
      variant="caption"
      sx={{
        px: 2,
        py: 0.5,
        borderRadius: "999px",
        fontWeight: 500,
        display: "inline-block",
        color,
        bgcolor: alpha(color, 0.2),
      }}
    >
      {label}
    </Typography>
  );
};
